import { usePopStore } from "../state/usePopStore";
import { copy } from "../content/copy";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function sinceLabel(firstAt: number): string {
  const d = new Date(firstAt);
  const today = new Date();
  const sameDay =
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate();
  return sameDay ? copy.passport.today : `${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

/**
 * The visitor's quiet one-line passport, sitting above the footer. A record,
 * not a boast — it renders nothing until they've actually popped something,
 * and reads once on mount (a stale count here costs nobody anything).
 */
export default function PopperLine() {
  const { myPopCount, myFirstPopAt } = usePopStore.getState();
  if (myPopCount <= 0) return null;
  let line = copy.passport.line.replace("{n}", myPopCount.toLocaleString("en-US"));
  line = line.replace("{when}", myFirstPopAt ? sinceLabel(myFirstPopAt) : copy.passport.today);
  return <p className="popper-line">{line}</p>;
}
